/**
 * @param {*} value
 * @param {*} validationValue
 * @returns {boolean}
 */
function minDate ({ value, validationValue }) {
  if (!validationValue) return true
  if (!value?.year || !value?.month || !validationValue?.year || !validationValue?.month) return false

  return new Date(value.year, value.month) >= new Date(validationValue.year, validationValue.month)
}

module.exports = { minDate }
